import { useEffect, useState } from "react";

import {signin, signinGoogle} from '../Firebase/auth'
import { getAuth } from "firebase/auth";

import google from '../assets/icon/google1.png'

import firebase from "../firebase";
import { useLocation, useNavigate } from "react-router-dom";

import { MuiOtpInput } from 'mui-one-time-password-input'

import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../firebase';

import './auth.css';

const backendURL = "https://suits-backend.vercel.app"

function Login() {
    const navigate = useNavigate()
    const location = useLocation()
    const [redirect, setRedirect] = useState("/")
    
    
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Adjusted breakpoint for layout switch

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [id, setId] = useState('');
    const [otp, setOtp] = useState('');

    const [state, setState] = useState(0) // 0: Input, 1: OTP

    const [emailOTP, setEmailOTP] =useState("456378")
    const [type, setType] = useState(0) // 0: Email, 1: Phone

    const [counter, setCounter] = useState(-1);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        // console.log("State is changing , ", state)
    }, [state])

    useEffect(()=>{
        if(location && location.state && location["state"]["from"]){
            setRedirect(redirect+location.state["from"])
        }
    }, [])

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
      }, [counter]);

    const generateRecaptcha = () => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha', {
                'size': 'invisible',
                'callback': (response) => {
                  // reCAPTCHA solved
                }
              });
        }
    }

    const sendEmailOTP = async()=>{
        try{
            setLoading(true);
            const o = Math.random().toString().substr(2, 6)
            setEmailOTP(o)
            const headers = {
                "Content-Type" : "application/json"
            }
        
            const params ={
                "email" : id,
                "otp": o
            }
            const resp = await fetch(`${backendURL}/sendOtp`, { method: 'POST', headers:headers,body:JSON.stringify(params)});
            const data = await resp.json();
            
            setState(1)
            setCounter(60)
            setLoading(false);

        }catch(e){
            console.log(e)
            setLoading(false);
            alert("Failed to send OTP. Please try again.");
        }
    }

    
    const handleChange = (newValue) => {
        setOtp(newValue)
    }

    const handleSend = () => {
        setLoading(true);
        generateRecaptcha();
        let appVerifier = window.recaptchaVerifier;
        // Ensure phone number format is correct
        const phoneNumber = id.length === 10 ? `+91${id}` : id.includes('+') ? id : `+91${id}`; // Defaulting to India if 10 digits
        
        signInWithPhoneNumber(auth, phoneNumber, appVerifier)
          .then((confirmationResult) => {
            console.log("otp sent")
            setState(1)
            setCounter(60)
            window.confirmationResult = confirmationResult;
            setLoading(false);
          }).catch((error) => {
            console.log(error);
            setLoading(false);
            alert("Failed to send OTP. Please check the number.");
          });
    }

    const verifyOtp = (a) => {
        // ... (existing verify logic if used directly, but currently using manual confirm)
    }

    const signinWithToken = async()=>{
        try{
            setLoading(true);
            const headers = {
                "Content-Type" : "application/json"
            }
        
            const params ={
                "email" : id
            }
            const resp = await fetch(`${backendURL}/customToken`, { method: 'POST', headers:headers,body:JSON.stringify(params)});
            const data = await resp.json();

            const u=await auth.signInWithCustomToken(data.customToken) 
            setLoading(false);
            navigate(redirect)
        } catch(e){ 
            console.log(e)
            setLoading(false);
            alert("Authentication failed.");
        }
    }

    const handleLoginSubmit = async () => {
        if(state === 0) {
            // Send OTP
            if(id && id.length > 0){
                if(type === 0){
                    await sendEmailOTP()
                } else{
                    handleSend()
                }
            }
        } else {
            // Verify OTP
            if(type === 0){
                if(emailOTP == otp){
                    await signinWithToken()
                } else {
                    alert("Invalid OTP");
                }
            } else {
                let confirmationResult = window.confirmationResult;
                setLoading(true);
                confirmationResult.confirm(otp).then((result) => {
                    // User signed in successfully.
                    setLoading(false);
                    navigate(redirect);
                }).catch((error) => {
                    setLoading(false);
                    alert('Invalid Verification Code');
                });
            }
        }
    }

    return ( 
    <div className="auth-container">
        <button className="auth-back-btn" onClick={() => navigate('/')}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
        </button>
        
        <div className="auth-form-wrapper">
            <div className="auth-form-section">
                <div className="auth-header-text">
                    <h1 className="auth-title">Welcome Back</h1>
                    <p className="auth-subtitle">Elevate your style with Maviinci</p>
                </div>

                {state === 0 && (
                    <>
                        <button className="auth-google-btn"
                            onClick={()=>{
                                signinGoogle().then(()=>{
                                    navigate(redirect)
                                }).catch((error)=>{console.log(error)})
                            }}
                        >
                            <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.66l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                            </svg>
                            <span>Continue with Google</span>
                        </button>

                    <div className="auth-divider">OR</div>

                    <div className="auth-toggle">
                        <div 
                            className={`auth-toggle-btn ${type === 0 ? 'active' : ''}`}
                            onClick={() => setType(0)}
                        >
                            Email
                        </div>
                        <div 
                            className={`auth-toggle-btn ${type === 1 ? 'active' : ''}`}
                            onClick={() => setType(1)}
                        >
                            Phone
                        </div>
                    </div>

                    <div className="auth-input-group">
                        <label className="auth-label">{type === 0 ? "Email Address" : "Phone Number"}</label>
                        <div style={{position: 'relative'}}>
                            {type === 1 && (
                                <span style={{position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280', fontSize: '1rem', fontWeight: '600'}}>
                                    +91
                                </span>
                            )}
                            <input 
                                className="auth-input"
                                style={type === 1 ? {paddingLeft: '55px'} : {}}
                                placeholder={type === 0 ? "name@example.com" : "00000 00000"}
                                value={id}
                                onChange={(e) => setId(e.target.value)}
                                type={type === 0 ? "email" : "tel"}
                                onKeyDown={(e) => e.key === 'Enter' && handleLoginSubmit()}
                            />
                        </div>
                    </div>
                </>
            )}

            {state === 1 && (
                <div className="otp-container">
                    <div className="otp-header">
                        <h3>Verify Identity</h3>
                        <p style={{color: '#6b7280', fontSize: '0.95rem', marginBottom: '2rem'}}>
                            Enter the 6-digit code sent to<br/>
                            <strong style={{color: '#14213D'}}>{type === 0 ? id : `+91 ${id}`}</strong>
                        </p>
                    </div>
                    
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom: '1rem'}}>
                        <MuiOtpInput 
                            value={otp} 
                            onChange={handleChange} 
                            length={6} 
                            TextFieldsProps={{
                                placeholder: '-',
                                inputProps: {
                                    style: { textAlign: 'center', fontSize: '1.2rem', fontWeight: '700' }
                                }
                            }}
                            gap={1.5}
                        />
                    </div>
                    
                    <div className="otp-resend">
                        {counter > 0 ? (
                            <span>Resend available in <strong>{counter}s</strong></span>
                        ) : (
                            <button 
                                style={{background: 'none', border: 'none', color: '#14213D', cursor: 'pointer', fontWeight: '700', textDecoration: 'underline', fontSize: '0.9rem'}}
                                onClick={() => {
                                    if(type === 0) sendEmailOTP();
                                    else handleSend();
                                }}
                            >
                                Resend Code
                            </button>
                        )}
                    </div>
                </div>
            )}

            <button 
                className="auth-submit-btn"
                disabled={loading || (state === 0 && !id) || (state === 1 && otp.length !== 6)}
                onClick={handleLoginSubmit}
            >
                {loading ? "Please wait..." : (state === 0 ? "Send OTP" : "Verify & Login")}
            </button>
            
            {state === 1 && (
                <button 
                    style={{
                        background: 'none', border: 'none', color: '#6b7280', 
                        marginTop: '1.5rem', cursor: 'pointer', fontSize: '0.9rem',
                        fontWeight: '600'
                    }}
                    onClick={() => {
                        setState(0);
                        setOtp('');
                    }}
                >
                    Edit {type === 0 ? "email address" : "phone number"}
                </button>
            )}

            <div className="auth-footer-links">
                Don't have an account? 
                <span className="auth-link" onClick={() => navigate('/register')} style={{cursor: 'pointer'}}>Register Now</span>
            </div>

            <div id="recaptcha"></div>
        </div>
        </div>
    </div> 
    );

}

export default Login;